import { notification } from "@mtm/components";
import { sendEmailSubscriptionRefund } from "../services/EmailNotificationService";
import {
  NotificationSubscriptionRefund,
} from "../types/EmailNotificationType";

const EmailSubscriptionRefund = async (
  refundRequest: NotificationSubscriptionRefund,  
) => {
  try {        
    await sendEmailSubscriptionRefund(refundRequest);
  } catch (error) {
    notification.error({
      message: "Error",
      description: "Failed to send email.",
    });
  }
};

export default EmailSubscriptionRefund;
